import { arrivalTimes } from './arrivalTimes';
import { baseSpaDay } from './baseSpaDay';
import { extras } from './extras';
import { inclusionsWithTimes } from './inclusions';
import { selectionsWithTimes } from './selections';

// Spa Package with arrival times, time slots supported and required, and a choice of options
export const scenario4 = {
  ...baseSpaDay,
  ...arrivalTimes,
  configurationGroupsRequireTimeslots: true,
  configurationGroupsSupportTimeslots: true,
  configurationGroups: [...inclusionsWithTimes, ...selectionsWithTimes, ...extras],
};
